export enum DiscountBlockType {
  BankHoliday = 0,
  Custom = 1,
  Weekend = 2,
}
